import SeoMeta from 'components/Basic/Head/SeoMeta/SeoMeta';

export default SeoMeta;
